import { render } from "./box-line-nowrap.vue?vue&type=template&id=149f8b8d"
import script from "./box-line-nowrap.vue?vue&type=script&lang=js"
export * from "./box-line-nowrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__